import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  completedOn: {
    id: 'containers.PatientIntakeFormAnswersPage.completedOn',
    defaultMessage: 'Completed on {completedTimestamp}',
  },
  sentToEHR: {
    id: 'containers.PatientIntakeFormAnswersPage.sentToEHR',
    defaultMessage: 'Sent to EHR: {statusSentToEHR}',
  },
  statusChangedBy: {
    id: 'containers.PatientIntakeFormAnswersPage.statusChangedBy',
    defaultMessage: 'Status changed by {updatedByName} on {updatedTimestamp}',
  },
  copayLegalText: {
    id: 'containers.PatientIntakeFormAnswersPage.copayLegalText',
    defaultMessage:
      'Note: Please contact {billingVendor} for any payment issues. Luma Health is not liable for any payment disputes or transactions.',
  },
  downloadPDF: {
    id: 'containers.PatientIntakeFormAnswersPage.downloadPDF',
    defaultMessage: 'Download PDF',
  },
  noTitle: {
    id: 'containers.PatientIntakeFormAnswersPage.noTitle',
    defaultMessage: '- no title -',
  },
  processingStatusOpen: {
    id: 'containers.PatientIntakeFormAnswersPage.processingStatusOpen',
    defaultMessage: 'Open',
  },
  processingStatusInProgress: {
    id: 'containers.PatientIntakeFormAnswersPage.processingStatusInProgress',
    defaultMessage: 'In Progress',
  },
  processingStatusClosed: {
    id: 'containers.PatientIntakeFormAnswersPage.processingStatusClosed',
    defaultMessage: 'Closed',
  },
  processingStatusScheduled: {
    id: 'containers.PatientIntakeFormAnswersPage.processingStatusScheduled',
    defaultMessage: 'Scheduled',
  },
  processingStatusNoResponse: {
    id: 'containers.PatientIntakeFormAnswersPage.processingStatusNoResponse',
    defaultMessage: 'No Response',
  },
  emptyTitleMain: {
    id: 'containers.PatientIntakeFormAnswersPage.emptyTitleMain',
    defaultMessage: '0 questions answered',
  },
  emptyTitleSecondary: {
    id: 'containers.PatientIntakeFormAnswersPage.emptyTitleSecondary',
    defaultMessage: 'The patient has skipped all questions.',
  },
  emptyTitleTertiary: {
    id: 'containers.PatientIntakeFormAnswersPage.emptyTitleTertiary',
    defaultMessage: 'Please contact the patient for more information.',
  },
  insuranceGroupName: {
    id: 'containers.PatientIntakeFormAnswersPage.insuranceGroupName',
    defaultMessage: 'Group Number',
  },
  memberName: {
    id: 'containers.PatientIntakeFormAnswersPage.memberName',
    defaultMessage: 'Member Name',
  },
  memberNumber: {
    id: 'containers.PatientIntakeFormAnswersPage.memberNumber',
    defaultMessage: 'Subscriber or Member Id',
  },
  payerName: {
    id: 'containers.PatientIntakeFormAnswersPage.payerName',
    defaultMessage: 'Insurance Name',
  },
  planName: {
    id: 'containers.PatientIntakeFormAnswersPage.planName',
    defaultMessage: 'Plan Name/Type',
  },
  primaryInsurance: {
    id: 'containers.PatientIntakeFormAnswersPage.primaryInsurance',
    defaultMessage: 'Primary Insurance',
  },
  additionalInsurance: {
    id: 'containers.PatientIntakeFormAnswersPage.additionalInsurance',
    defaultMessage: 'Additional Insurance',
  },
  memberDetails: {
    id: 'containers.PatientIntakeFormAnswersPage.memberDetails',
    defaultMessage: 'Member Details',
  },
  dependentDetails: {
    id: 'containers.PatientIntakeFormAnswersPage.dependentDetails',
    defaultMessage: 'Dependent Details',
  },
  dependentName: {
    id: 'containers.PatientIntakeFormAnswersPage.dependentName',
    defaultMessage: 'Dependent Name',
  },
  dependentDOB: {
    id: 'containers.PatientIntakeFormAnswersPage.dependentDOB',
    defaultMessage: 'Date of Birth',
  },
  relationshipToSubscriber: {
    id: 'containers.PatientIntakeFormAnswersPage.relationshipToSubscriber',
    defaultMessage: 'Relationship to Subscriber',
  },
  dependentAddress: {
    id: 'containers.PatientIntakeFormAnswersPage.dependentAddress',
    defaultMessage: 'Address',
  },
  insuranceTitle: {
    id: 'containers.PatientIntakeFormAnswersPage.insuranceTitle',
    defaultMessage: 'Insurance Information',
  },
});
